import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';

export interface EventWizardVenueModalProps {
  // add props here
}

export const openEventWizardVenueModal = (): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.EVENT_WIZARD_VENUE_MODAL,
      panelProps: {},
    })
  );
};
